/*
  Motureo (W1): przycisk powrotu na górę i stan ładowania list produktów (snippets/motureo-ui.liquid). Bez zależności.
  Ładowanie: Horizon przy filtrowaniu i sortowaniu wysyła zdarzenia „shopify:collection:update” i
  „shopify:search:update” z obietnicą renderu sekcji; do czasu jej rozstrzygnięcia siatka ma aria-busy="true"
  i klasę szkieletu (motureo.css, blok W1). Zdarzenia z podpowiedzi wyszukiwania w nagłówku pomijamy.
*/

const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

/* --- Powrót na górę: po przewinięciu dwóch wysokości okna --- */
const top = document.querySelector('[data-motureo-top]');
if (top instanceof HTMLElement) {
  let ticking = false;
  const update = () => {
    ticking = false;
    const show = window.scrollY > window.innerHeight * 2;
    if (top.hidden === show) top.hidden = !show;
  };
  window.addEventListener(
    'scroll',
    () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    },
    { passive: true }
  );
  update();
  top.addEventListener('click', (event) => {
    event.preventDefault();
    const main = document.getElementById('MainContent');
    if (main) {
      if (!main.hasAttribute('tabindex')) main.setAttribute('tabindex', '-1');
      main.focus({ preventScroll: true });
    }
    window.scrollTo({ top: 0, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
  });
}

/* --- Stan ładowania list produktów --- */
const status = document.querySelector('[data-motureo-loading-status]');

function gridFor(target) {
  const section = target instanceof Element ? target.closest('.shopify-section') : null;
  return (section || document).querySelector('.product-grid') || document.querySelector('.product-grid');
}

function onListUpdate(event) {
  const target = event.target;
  if (target instanceof Element && target.closest('predictive-search-component')) return;
  const promise = /** @type {any} */ (event).promise;
  const grid = gridFor(target);
  if (!grid || !promise || typeof promise.finally !== 'function') return;
  grid.setAttribute('aria-busy', 'true');
  grid.classList.add('motureo-is-loading');
  if (status) status.textContent = status.dataset.text || '';
  promise
    .catch(() => {})
    .finally(() => {
      // sekcja może zostać podmieniona: zdejmujemy stan z każdej siatki, która go ma
      document.querySelectorAll('.product-grid.motureo-is-loading').forEach((el) => {
        el.classList.remove('motureo-is-loading');
        el.removeAttribute('aria-busy');
      });
      if (status) status.textContent = '';
    });
}

document.addEventListener('shopify:collection:update', onListUpdate);
document.addEventListener('shopify:search:update', onListUpdate);
